import {querySelectorAll} from '../utilities';

document.addEventListener('DOMContentLoaded', () => {
  const inputs = querySelectorAll('input.postal-code-input');
  inputs.forEach((input: HTMLInputElement) => {
    input.addEventListener('blur', e => {
      const target = e.target as HTMLInputElement;
      if (target && target.value) {
        const oldValue = target.value;
        target.value = target.value.replace(/[^0-9]/g, '');
        if (oldValue !== target.value) {
          target.dispatchEvent(new Event('input', {bubbles: true}));
        }
      }
    });
  });

  const forms = querySelectorAll('form');
  forms.forEach((form: HTMLFormElement) => {
    form.addEventListener('submit', e => {
      const container = e.target as HTMLFormElement;
      const inputs = querySelectorAll('input.postal-code-input', container);
      inputs.forEach((input: HTMLInputElement) => {
        if (input && input.value) {
          input.value = input.value.replace(/[^0-9]/g, '');
        }
      });
    });
  });
});
